import { render, staticRenderFns } from "./ContractItemDialog.vue?vue&type=template&id=f00bcc0c&scoped=true"
import script from "./ContractItemDialog.vue?vue&type=script&lang=js"
export * from "./ContractItemDialog.vue?vue&type=script&lang=js"
import style0 from "./ContractItemDialog.vue?vue&type=style&index=0&id=f00bcc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00bcc0c",
  null
  
)

export default component.exports